import * as yup from 'yup';
import { FIELD_LIMITS } from 'utils/character-count-utils';

const feedbackFormValidation = yup.object().shape({
  adminComment: yup.string().trim().max(FIELD_LIMITS.ADMIN_COMMENT.maxLength, `Admin comment must be at most ${FIELD_LIMITS.ADMIN_COMMENT.maxLength} characters`).label('Admin Comment'),
  isCompleted: yup.boolean(),
});

export const adminCommentFieldConfig = FIELD_LIMITS.ADMIN_COMMENT;

export default feedbackFormValidation;
